export default __webpack_public_path__ + "66f93e1ef4956c76362d63e1fb2d22b3dd655e5777c98af91bf1b56919e755c5.png";